/**
 * Badges de estado y prioridad de una tarea — fuente única.
 *
 * Las cuatro vistas de `/tareas` (lista, cards, kanban, timeline) tenían cada
 * una su propia copia de estos mapas, y las cuatro estaban incompletas de la
 * misma forma:
 *
 *   - `priority` admite `urgent` (CHECK de `tasks`: low|medium|high|urgent) y
 *     ninguna copia lo mapeaba, así que las 4 tareas `urgent` de producción se
 *     pintaban como "Media" por el fallback. Una tarea urgente que la pantalla
 *     llama "Media" es peor que no mostrar prioridad.
 *   - `status` admite seis valores (pending|in_progress|blocked|review|
 *     completed|cancelled) y las copias mapeaban tres: `blocked`, `review` y
 *     `cancelled` se pintaban como "Pendiente".
 *
 * Cualquier valor nuevo del CHECK se agrega ACÁ y las cuatro vistas quedan
 * consistentes; ese es el punto de que este archivo exista.
 *
 * @module components/tasks/shared/taskBadges
 */

import { TASK_STATUS, TASK_PRIORITY } from '../../../utils/constants';

export const TASK_STATUS_BADGES = {
  [TASK_STATUS.PENDING]: { bg: 'secondary', text: 'Pendiente' },
  [TASK_STATUS.IN_PROGRESS]: { bg: 'primary', text: 'En Progreso' },
  [TASK_STATUS.BLOCKED]: { bg: 'danger', text: 'Bloqueada' },
  [TASK_STATUS.REVIEW]: { bg: 'info', text: 'En Revisión' },
  [TASK_STATUS.COMPLETED]: { bg: 'success', text: 'Completada' },
  [TASK_STATUS.CANCELLED]: { bg: 'dark', text: 'Cancelada' },
};

// Los colores siguen la convención que ya usa `formatTaskPriority`
// (src/utils/formatters.js), que es lo que pinta la cabecera del detalle: si
// acá se usara otra escala, la misma tarea se vería de un color en la lista y
// de otro al abrirla.
export const TASK_PRIORITY_BADGES = {
  [TASK_PRIORITY.URGENT]: { bg: 'danger', text: 'Urgente' },
  [TASK_PRIORITY.HIGH]: { bg: 'danger', text: 'Alta' },
  [TASK_PRIORITY.MEDIUM]: { bg: 'warning', text: 'Media' },
  [TASK_PRIORITY.LOW]: { bg: 'secondary', text: 'Baja' },
};

/**
 * @param {string} status
 * @returns {{bg: string, text: string}}
 */
export const getStatusBadge = (status) =>
  TASK_STATUS_BADGES[status] || TASK_STATUS_BADGES[TASK_STATUS.PENDING];

/**
 * @param {string} priority
 * @returns {{bg: string, text: string}}
 */
export const getPriorityBadge = (priority) =>
  TASK_PRIORITY_BADGES[priority] || TASK_PRIORITY_BADGES[TASK_PRIORITY.MEDIUM];
